<template>
	<div class="container">
		<div class="page">
			<div class="contentBlock fontLarge">
				<div class="logoCentered paddingTop paddingBottomMore">
					<img
						:src="logoUrl"
						alt="Logo"
					/>
				</div>
			</div>
			<div class="contentBlock">
				<span class="fontLarge">Thank you.</span>
				<br />
				<br />
				Your consignment contract has been signed and received. A copy of your signed contract has
				been sent to the email address specified on the contract.
				<br />
				<br />
				Thank you for allowing us to represent your collection at auction.
				<br />
				<br />
			</div>
		</div>
	</div>
</template>

<script>
	import contractState from '../../../mixins/contractState'
	export default {
		name: 'Signed',
		mixins: [contractState],
		mounted() {}
	}
</script>

<style scoped></style>
